import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Wrapper = styled.div`
  // background: ${props => props.theme.colors.pastelblue};
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 1em auto;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidth};
  padding: 0 0 2em;
  a {
    position: relative;
    background: ${props => props.theme.colors.highlight};
    color: white;
    height: 46px;
    line-height: 46px;
    text-decoration: none;
    font-weight: bold;
    font-size: 14px;
    &:before {
      content:"";
      position:absolute;
      height: 0px;
      width: 0px;
    }
    &:hover {
      background: #333;
      &:before {
        border-color: #333;
      }
    }
  }
`

const PreviousLink = styled(Link)`
  margin-right: auto;
  order: 1;
  margin-left: 19px;
  padding: 0 12px 0 7px;
  &:before {
    border-bottom: 23px solid transparent !important;
    border-right: 18px solid ${props => props.theme.colors.highlight};
    border-top: 23px solid transparent !important;
    left: -18px;
    top: 0;
  }
`

const NextLink = styled(Link)`
  margin-left: auto;
  order: 3;
  margin-right: 19px;
  padding: 0 7px 0 12px;
  &:before {
    border-bottom: 23px solid transparent !important;
    border-left: 18px solid ${props => props.theme.colors.highlight};
    border-top: 23px solid transparent !important;
    margin-left: -25px;
    right: -18px;
    top: 0;
  }
`

const PageIndicator = styled.span`
  color: gray;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  text-align: center;
  padding: 1em 1.5em;
  z-index: -1;
  opacity: 0.7;
`

class Pagination extends React.Component {
  render() {
    const { numPages, currentPage, slug } = this.props.context
    const isFirst = currentPage === 1
    const isLast = currentPage === numPages
    const isNotPaginated = isFirst & isLast

    const prevPageNum = currentPage - 1 === 1 ? `` : currentPage - 1
    const nextPageNum = currentPage + 1

    const pathPrefix = typeof slug === 'string' ? `/tag/${slug}` : ''
    const prevPageLink = isFirst ? null : `${pathPrefix}/${prevPageNum}/`
    const nextPageLink = isLast ? null : `${pathPrefix}/${nextPageNum}/`

    return (
      <Wrapper>
        {!isFirst && <PreviousLink to={prevPageLink}>前のページ</PreviousLink>}
        {!isNotPaginated && (
          <PageIndicator>
            {currentPage}/{numPages}
          </PageIndicator>
        )}
        {!isLast && <NextLink to={nextPageLink}>次のページ</NextLink>}
      </Wrapper>
    )
  }
}

export default Pagination
